
import Vue, { PropType } from "vue";
import { Website } from "@/models";

import WebsiteListHeader from "./WebsiteListHeader.vue";
import WebsiteListItem from "./WebsiteListItem.vue";

export default Vue.extend({
  name: "WebsiteList",

  props: {
    websites: Array as PropType<Array<Website>>,
  },

  components: {
    WebsiteListHeader,
    WebsiteListItem,
  },
});
